<app-dialog-header (backClick)="onNoClick()" [canClose]="canClose()" [header]="header"></app-dialog-header>

<div class="content dialog-view-wrapper no-select-clickable-items">

  <div *ngIf="showSelectAllButton && useMultiSelection" class="action-buttons">
    <button mat-flat-button class="button small-button" (click)="selectOrDisableAll()">
      <mat-icon>{{ getSelectAllIcon() }}</mat-icon>
      <p>{{ getSelectAllText() }}</p>
    </button>
  </div>

  <h2 *ngIf="headerInfo" class="panel-title">{{ headerInfo }}</h2>
  <p *ngIf="headerInfoSmall" class="p-formfield-info">{{ headerInfoSmall }}</p>

  <ng-container *ngIf="showSearch">
    <app-search-bar (onSearchTextChanged)="onSearchTextChanged($event)"></app-search-bar>
  </ng-container>

  <div class="scrolling-container panel custom-selection">
    <!-- Single selection -->
    <div class="container panel" *ngIf="!useMultiSelection">
      <mat-nav-list class="remove-padding" *ngFor="let option of options | filter: searchText; let lastItem = last;">
        <mat-list-item (click)="setSelectedValue(option.value)">
          <div class="option-wrapper">
            <div class="option-text">{{ option.displayText ?? option.value }}</div>
            <div class="option-icon">
              <mat-icon *ngIf="option.value === selectedValue">check</mat-icon>
            </div>
          </div>
        </mat-list-item>
        <mat-divider class="divider-class" *ngIf="!lastItem"></mat-divider>
      </mat-nav-list>
    </div>

    <!-- Multi selection -->
    <div class="container panel" *ngIf="useMultiSelection">
      <mat-selection-list [(ngModel)]="selectedOptions" (selectionChange)="onSelectionChange($event)">
        <div *ngFor="let option of options; let lastItem = last;">
          <mat-list-option [value]="option.value" [checkboxPosition]="'before'">
            <div class="option-wrapper">
              <div class="option-text">{{ option.displayText ?? option.value }}</div>
            </div>
          </mat-list-option>
          <mat-divider class="divider-class" *ngIf="!lastItem"></mat-divider>
        </div>
      </mat-selection-list>
    </div>
  </div>
</div>
